import React from "react";

import { Table } from "components/Common/clearsense-ui/components";

import { COLUMN_DATA } from "./column";

import Card from "../Card";

const DatasetsHome = ({ isTableView, datasets, isLoading }) => (
  <>
    {isTableView ? (
      <div className="mt-5 h-[calc(100vh-305px)]">
        <Table
          columnData={COLUMN_DATA}
          rowKey={record => record.id}
          rowData={datasets}
          allowRowClick={false}
          isLoading={isLoading}
          fixedHeight
        />
      </div>
    ) : (
      <div className="grid gap-4 mt-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {datasets?.map(dataset => (
          <Card key={dataset.id} dataset={dataset} />
        ))}
      </div>
    )}
  </>
);

export default DatasetsHome;
